import { tr as __tr, useLocale as __useLocale, direction as __direction, localizedField as __localizedField } from "../i18n/runtime";
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Search, Menu, X, ChevronDown, Globe, User } from 'lucide-react';
import { Button } from './ui/button';
import { useLanguage } from '../i18n/LanguageContext';
import { useAuth } from '../context/AuthContext';
const Navbar = () => {
  __useLocale();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const {
    t,
    language,
    toggleLanguage
  } = useLanguage();
  const {
    user,
    isAuthenticated,
    logout
  } = useAuth();
  const navItems = [{
    name: t('nav.hotels'),
    href: '#hotels'
  }, {
    name: t('nav.visas'),
    href: '#visas'
  }, {
    name: t('nav.buses'),
    href: '#buses'
  }, {
    name: t('nav.flights'),
    href: '#flights'
  }, {
    name: t('nav.news'),
    href: '#news'
  }, {
    name: t('nav.faq'),
    href: '#faq'
  }];
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-sm" dir={language === 'ar' ? 'rtl' : 'ltr'}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Left side - Auth buttons */}
          <div className="hidden md:flex items-center gap-3">
            {__tr(isAuthenticated ? <>
                <Link to="/dashboard">
                  <Button variant="ghost" className="text-gray-700 hover:text-[#6B5B95] hover:bg-purple-50 rounded-full px-4 py-2 text-sm font-medium transition-all">
                    <User className="w-4 h-4 ml-2" />
                    {__tr(user?.full_name)}
                  </Button>
                </Link>
                <Button onClick={logout} variant="ghost" className="text-red-600 hover:bg-red-50 rounded-full px-4 py-2 text-sm font-medium transition-all">
                  {__tr(t('nav.logout'))}
                </Button>
              </> : <>
                <Link to="/register">
                  <Button className="bg-gradient-to-r from-[#FF8C42] to-[#FF6B35] hover:from-[#FF6B35] hover:to-[#FF8C42] text-white rounded-full px-5 py-2 text-sm font-medium transition-all duration-300">
                    {__tr(t('nav.register'))}
                    <ChevronDown className="w-4 h-4 mr-1" />
                  </Button>
                </Link>
                <Link to="/login">
                  <Button variant="ghost" className="text-gray-700 hover:text-[#6B5B95] hover:bg-purple-50 rounded-full px-4 py-2 text-sm font-medium transition-all">
                    {__tr(t('nav.login'))}
                  </Button>
                </Link>
              </>)}
          </div>

          {/* Center - Navigation Items */}
          <div className="hidden md:flex items-center gap-1">
            <Button variant="ghost" onClick={toggleLanguage} className="text-gray-600 hover:text-[#6B5B95] hover:bg-purple-50 rounded-full px-3 py-2 text-sm transition-all">
              <Globe className="w-4 h-4 ml-1" />
              {__tr(language === 'ar' ? 'English' : "العربية")}
            </Button>
            {__tr(navItems.map((item, index) => <a key={index} href={`/${item.href}`} onClick={() => setMobileMenuOpen(false)} className="text-gray-700 hover:text-[#6B5B95] hover:bg-purple-50 rounded-full px-3 py-2 text-sm font-medium transition-all">
                {__tr(__localizedField(item, "name"))}
              </a>))}
            <Button variant="ghost" aria-label={__tr("بحث")} onClick={() => {
            window.location.href = "/#hotels";
          }} className="text-gray-600 hover:text-[#6B5B95] p-2 rounded-full transition-all">
              <Search className="w-5 h-5" />
            </Button>
          </div>

          {/* Right side - Logo */}
          <div className="flex items-center">
            <Link to="/" className="flex items-center cursor-pointer">
              <span className="text-3xl font-bold text-[#6B5B95]">{__tr(t('brand'))}</span>
              <span className="text-[#FF8C42] text-3xl mr-1">✈</span>
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <Button variant="ghost" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="p-2">
              {__tr(mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />)}
            </Button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {__tr(mobileMenuOpen && <div className="md:hidden bg-white border-t shadow-lg">
          <div className="px-4 py-4 space-y-2">
            {__tr(navItems.map((item, index) => <a key={index} href={`/${item.href}`} onClick={() => setMobileMenuOpen(false)} className="block w-full text-right px-4 py-3 text-gray-700 hover:bg-purple-50 hover:text-[#6B5B95] rounded-lg transition-all">
                {__tr(__localizedField(item, "name"))}
              </a>))}
            <Button variant="ghost" onClick={toggleLanguage} className="w-full justify-start">
              <Globe className="w-4 h-4 ml-2" />
              {__tr(language === 'ar' ? 'English' : "العربية")}
            </Button>
            <div className="pt-4 border-t flex flex-col gap-2">
              {__tr(isAuthenticated ? <>
                  <Link to="/dashboard">
                    <Button className="w-full bg-[#6B5B95] text-white rounded-full">
                      {__tr(t('nav.dashboard'))}
                    </Button>
                  </Link>
                  <Button onClick={logout} variant="outline" className="w-full rounded-full text-red-600">
                    {__tr(t('nav.logout'))}
                  </Button>
                </> : <>
                  <Link to="/register">
                    <Button className="w-full bg-gradient-to-r from-[#FF8C42] to-[#FF6B35] text-white rounded-full">
                      {__tr(t('nav.register'))}
                    </Button>
                  </Link>
                  <Link to="/login">
                    <Button variant="outline" className="w-full rounded-full">
                      {__tr(t('nav.login'))}
                    </Button>
                  </Link>
                </>)}
            </div>
          </div>
        </div>)}
    </nav>;
};
export default Navbar;
